import React from 'react';
import ReactDOM from 'react-dom';
import { useLocation } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './pages/management';
import Footer from './components/footer';

import Home from './pages/home';

import Nav from './nav';
import {
    BrowserRouter, Route, Navigate, Routes, Outlet, Link,
    useParams
} from "react-router-dom";
import * as serviceWorker from './serviceWorker';

import logo from './assets/images/asccp_logo_white.png';
import facebook from './assets/images/facebook.png';
import twitter from './assets/images/twitter.png';
import instagram from './assets/images/insta.png';
import ScrollToTop from "./pages/components/scrollToTop";

import { pdfjs } from 'react-pdf';
export const getWorker = () => {
    try {
        return require('react-pdf/node_modules/pdfjs-dist/legacy/build/pdf.worker.entry.js')
    } catch (ex) {
        return require('pdfjs-dist/legacy/build/pdf.worker.entry.js')
    }
}
pdfjs.GlobalWorkerOptions.workerSrc = getWorker();

let algorithms = require('./data/algorithms.json');

function link_safe(algorithm) {
    algorithm = algorithm.replace(/\,/g, '');
    algorithm = algorithm.replace(/\s+/g, '-');
    algorithm = algorithm.replace(/\//g, '-');
    return algorithm.toLowerCase();
}

function Header() {
    return (<div />);
}

const routes = (
    <div>
        <BrowserRouter>

            <ScrollToTop />
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />

            <Header />

            <Routes>
                <Route path="/" element={<AppLoad />} />
            </Routes>
        </BrowserRouter>
    </div>
);

function AppLoad() {

    let page = useParams()["*"];
    if (page != "") {
        let algorithm = algorithms.find(a => link_safe(a.title) === page);

        return (
            <div className="container">
                <App algo={algorithm} />
            </div>
        );
    } else {
        return (
            <div className="container">
                <App />
            </div>
        );
    }
}

ReactDOM.render(routes, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
